import PropTypes from 'prop-types';
import Image from 'next/image';

function SideImage(props) {
  return (
    <div className="bg-neutral-0 h-full relative" data-testid="side-image">
      <Image
        src={props.src}
        fill
        alt="side backgroun image"
        sizes="100vw"
        style={{ objectFit: 'cover', objectPosition: 'center' }}
        unoptimized={true}
      />
    </div>
  );
}

SideImage.propTypes = {
  src: PropTypes.string,
};

export default SideImage;
